function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVolumeMute = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13.636,
    viewBox: "0 0 16 13.636",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.09 1.515h-.454a1.515 1.515 0 0 0-1.094.467L4.726 4.924H1.515v3.788h3.211l2.816 2.942a1.515 1.515 0 0 0 1.094.467h.454zM4.079 3.409 6.447.935A3.03 3.03 0 0 1 8.637 0h1.211a.758.758 0 0 1 .758.758v12.12a.758.758 0 0 1-.758.758H8.636a3.03 3.03 0 0 1-2.188-.936l-2.369-2.473H1.515A1.515 1.515 0 0 1 0 8.712V4.924a1.515 1.515 0 0 1 1.515-1.515zm10.629 3.409 1.07 1.071a.757.757 0 1 1-1.071 1.071l-1.071-1.071-1.071 1.071a.757.757 0 1 1-1.071-1.071l1.071-1.071-1.072-1.071a.757.757 0 1 1 1.071-1.071l1.071 1.071 1.071-1.071a.757.757 0 1 1 1.071 1.071l-1.07 1.071z",
    style: {
      fill: "#222"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVolumeMute);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/volume-mute.cfed8beee0f11db44919abd54a57f8ea.svg";